// 文案管理
import { requestGetNew, requestPost } from '@/services/request';

export async function getSignupExplain(certId: string) {
  return requestGetNew(`/v1/console/get/signup/explain?certId=${certId}`, {});
}

export async function updateSignupExplain(params: {
  id: string;
  content: string;
}) {
  return requestPost('/v1/console/update/signup/explain', params);
}
